<div id="app">
    <div class="row">
        <div class="col-lg-2 col-md-12 ">
            <img class="img-fluid" src="assets/images/enea.png" id="logo">
        </div>
        <div class="col-lg-8">
            <div class="title">Rezerwacja wizyty w Biurze Obsługi Klienta</div>
        </div>
    </div>
    <div style="margin: 20px 0px 80px;">
        <div class="line-cont">
            <div class="oval oval-full">
                <span class="checkmark">
                    <div class="checkmark_circle"></div>
                    <div class="checkmark_stem"></div>
                    <div class="checkmark_kick"></div>
                </span>
                <span class="text">Wybór BOK</span>
            </div>
            <div class="line line-full">
                <span></span>
            </div>
            <div class="oval"
                [ngClass]="{'oval-full': ticketReservationService.reservationState >= ReservationState.Confirm, 'oval-trans': ticketReservationService.reservationState == ReservationState.Make}">
                <span *ngIf="ticketReservationService.reservationState == ReservationState.Make" class="circle">
                    <div class="circle_inner"></div>
                </span>
                <span *ngIf="ticketReservationService.reservationState >= ReservationState.Confirm" class="checkmark">
                    <div class="checkmark_circle"></div>
                    <div class="checkmark_stem"></div>
                    <div class="checkmark_kick"></div>
                </span>
                <span class="text">Dane i termin wizyty</span>
            </div>
            <div class="line"
                [ngClass]="{'line-full': ticketReservationService.reservationState >= ReservationState.Confirm, 'line-half': ticketReservationService.reservationState == ReservationState.Make}">
                <span></span>
            </div>
            <div class="oval" [ngClass]="{'oval-trans': ticketReservationService.reservationState == ReservationState.Confirm, 'oval-full': ticketReservationService.reservationState >= ReservationState.Summary}">
                <span *ngIf="ticketReservationService.reservationState == ReservationState.Confirm" class="circle">
                    <div class="circle_inner"></div>
                </span>
                <span *ngIf="ticketReservationService.reservationState == ReservationState.Summary" class="checkmark">
                    <div class="checkmark_circle"></div>
                    <div class="checkmark_stem"></div>
                    <div class="checkmark_kick"></div>
                </span>
                <span class="text">Potwierdzenie rezerwacji</span>
            </div>
        </div>
    </div>
</div>